import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import { useTranslation } from "@i18n";
import SingleQuest from "./components/SingleQuest/SingleQuest";
import stl from "./FAQV2.module.css";
import useHelpers from "@hooks/useHelpers";
var FAQ = function FAQ(_ref) {
  var faqs = _ref.faqs,
    faqsPage = _ref.faqsPage,
    isHomePage = _ref.isHomePage;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var _useState = useState(0),
    activeQustIndex = _useState[0],
    setActiveQustIndex = _useState[1];
  var setNewIndex = function setNewIndex(i) {
    if (isHomePage) {
      setActiveQustIndex(i);
      return;
    }
    setActiveQustIndex(function (pre) {
      return pre === i ? -1 : i;
    });
  };
  useEffect(function () {
    if (isHomePage) return;
    setActiveQustIndex(0);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("section", {
    className: "".concat(stl.faqContainer, " ").concat(isHomePage ? stl.homePage : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, isHomePage && /*#__PURE__*/React.createElement("h2", {
    className: ["big", "centRev", stl.hdrT].join(" ")
  }, t("اسئلة متكررة", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.allFAQCont
  }, faqs && faqs.length > 0 && faqs.map(function (item, i) {
    return /*#__PURE__*/React.createElement(SingleQuest, {
      key: i,
      onClick: function onClick() {
        setNewIndex(i);
      },
      qust: item.question,
      ans: item.answer,
      showAns: activeQustIndex === i,
      faqsPage: faqsPage
    });
  })), isHomePage && /*#__PURE__*/React.createElement("a", {
    href: createUrl('/faq')
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(stl.moreFaq, " ").concat(stl.whtBtn, " m-hide")
  }, t("اعرض المزيد", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("span", {
    className: "m-show ".concat(stl.mobLink)
  }, t("المزيد من الاسئلة المتكررة", {
    ns: "web_common"
  }))))));
};
export default FAQ;